export interface Video {
  id: number;
  title: string;
  category: string;
  thumbnail: string;
  duration: string;
  views: string;
  rating: number;
  description: string;
  tags: string[];
  releaseDate: string;
  director: string;
  cast: string[];
  featured: boolean;
}

export const videos: Video[] = [
  {
    id: 1,
    title: '流浪地球3：星际远征',
    category: 'movie',
    thumbnail: 'https://readdy.ai/api/search-image?query=futuristic%20sci-fi%20movie%20scene%20with%20spaceship%20and%20earth%20in%20background%2C%20cinematic%20blue%20and%20orange%20lighting%2C%20dramatic%20composition%2C%20movie%20poster%20quality%2C%20epic%20scale%2C%20dark%20space%20backdrop%20with%20stars%2C%20clean%20professional%20cinematography&width=640&height=360&seq=video-thumb-01&orientation=landscape',
    duration: '02:18:45',
    views: '1280万',
    rating: 9.2,
    description: '在太阳急速衰老膨胀的未来，人类面临前所未有的生存危机。联合政府启动"流浪地球计划"，倾全球之力在地球表面建造上万座发动机和转向发动机，推动地球离开太阳系，踏上长达2500年的宇宙流浪之旅。本片延续前作宏大叙事，展现人类在星际远征中的勇气与智慧。',
    tags: ['科幻', '灾难', '国产大片', 'IMAX'],
    releaseDate: '2026-01-22',
    director: '郭帆',
    cast: ['吴京', '刘德华', '李雪健', '沙溢', '宁理'],
    featured: true,
  },
  {
    id: 2,
    title: '长安三万里：诗画大唐',
    category: 'anime',
    thumbnail: 'https://readdy.ai/api/search-image?query=ancient%20Chinese%20Tang%20dynasty%20animation%20scene%20with%20traditional%20architecture%20and%20poets%20in%20flowing%20robes%2C%20warm%20golden%20and%20red%20tones%2C%20artistic%20watercolor%20style%2C%20elegant%20composition%2C%20soft%20diffused%20lighting%2C%20cultural%20heritage%20aesthetic&width=640&height=360&seq=video-thumb-02&orientation=landscape',
    duration: '02:48:20',
    views: '980万',
    rating: 9.5,
    description: '以盛唐为背景，讲述高适与李白跨越数十载的深厚情谊。影片以诗为媒，以画为景，将大唐盛世的风华绝代与文人墨客的豪情壮志融入每一帧画面，带观众穿越千年，感受中华文化的博大精深。',
    tags: ['动画', '历史', '文化', '国风'],
    releaseDate: '2025-07-08',
    director: '谢君伟',
    cast: ['杨天翔', '凌振赫', '吴俊全'],
    featured: true,
  },
  {
    id: 3,
    title: '乘风破浪的姐姐·第五季',
    category: 'variety',
    thumbnail: 'https://readdy.ai/api/search-image?query=glamorous%20stage%20performance%20with%20spotlights%20and%20colorful%20confetti%2C%20elegant%20female%20performers%20in%20sparkling%20dresses%2C%20variety%20show%20aesthetic%2C%20vibrant%20magenta%20and%20gold%20lighting%2C%20concert%20stage%20with%20dynamic%20energy%2C%20professional%20broadcast%20quality&width=640&height=360&seq=video-thumb-03&orientation=landscape',
    duration: '01:35:12',
    views: '2560万',
    rating: 8.8,
    description: '第五季重磅回归，30位30+姐姐再度集结，用舞台实力打破年龄界限。本季赛制全面升级，引入国际导师团队，姐姐们将在音乐、舞蹈、戏剧等多维度展开激烈角逐，呈现最燃最飒的女性力量。',
    tags: ['综艺', '音乐', '女性', '竞技'],
    releaseDate: '2026-03-15',
    director: '吴梦知',
    cast: ['宁静', '那英', '王心凌', '郑秀妍'],
    featured: true,
  },
  {
    id: 4,
    title: '舌尖上的中国·第五季',
    category: 'documentary',
    thumbnail: 'https://readdy.ai/api/search-image?query=steaming%20hot%20Chinese%20cuisine%20close-up%20with%20rich%20colors%20and%20textures%2C%20traditional%20kitchen%20setting%20with%20wooden%20utensils%2C%20warm%20ambient%20lighting%2C%20food%20documentary%20style%2C%20shallow%20depth%20of%20field%2C%20appetizing%20presentation&width=640&height=360&seq=video-thumb-04&orientation=landscape',
    duration: '00:52:30',
    views: '1850万',
    rating: 9.6,
    description: '从山海之间到市井烟火，第五季以全新视角探访中国各地的美食文化。节目深入挖掘每一道菜肴背后的家族传承与地域故事，用镜头记录食物与人的情感联结，呈现中华饮食文化的博大精深与时代变迁。',
    tags: ['纪录片', '美食', '文化', '人文'],
    releaseDate: '2026-05-01',
    director: '陈晓卿',
    cast: ['李立宏'],
    featured: true,
  },
  {
    id: 5,
    title: '周杰伦2026世界巡回演唱会·上海站',
    category: 'music',
    thumbnail: 'https://readdy.ai/api/search-image?query=massive%20concert%20stage%20with%20laser%20lights%20and%20huge%20LED%20screens%2C%20packed%20stadium%20audience%20with%20light%20sticks%2C%20dramatic%20blue%20and%20purple%20stage%20lighting%2C%20epic%20live%20music%20performance%20atmosphere%2C%20professional%20concert%20photography&width=640&height=360&seq=video-thumb-05&orientation=landscape',
    duration: '02:05:48',
    views: '3580万',
    rating: 9.8,
    description: '华语乐坛天王周杰伦2026世界巡回演唱会上海站完整版。从《稻香》到《青花瓷》，从《告白气球》到最新专辑热单，一场穿越20年音乐时光的视听盛宴，每首歌都是青春的记忆。',
    tags: ['演唱会', '音乐', '华语', '现场'],
    releaseDate: '2026-04-18',
    director: '周杰伦',
    cast: ['周杰伦', '刘畊宏', '派伟俊'],
    featured: false,
  },
  {
    id: 6,
    title: 'CBA总决赛2026：广东vs辽宁',
    category: 'sports',
    thumbnail: 'https://readdy.ai/api/search-image?query=intense%20basketball%20game%20moment%20with%20players%20dunking%2C%20packed%20arena%20with%20cheering%20fans%2C%20dynamic%20sports%20action%20shot%2C%20dramatic%20arena%20lighting%2C%20professional%20sports%20photography%2C%20high%20energy%20atmosphere&width=640&height=360&seq=video-thumb-06&orientation=landscape',
    duration: '01:52:30',
    views: '2150万',
    rating: 9.1,
    description: 'CBA 2025-2026赛季总决赛第七场决胜局，广东宏远对阵辽宁本钢。双方激战至最后一秒，全场比分交替领先超过20次，堪称CBA历史上最精彩的总决赛之一。',
    tags: ['体育', '篮球', 'CBA', '总决赛'],
    releaseDate: '2026-05-20',
    director: '央视体育',
    cast: ['易建联', '郭艾伦', '赵继伟', '胡明轩'],
    featured: false,
  },
  {
    id: 7,
    title: '城市漫步·成都慢生活',
    category: 'short',
    thumbnail: 'https://readdy.ai/api/search-image?query=bustling%20Chengdu%20street%20scene%20with%20traditional%20teahouse%20and%20modern%20cityscape%2C%20warm%20afternoon%20sunlight%2C%20locals%20enjoying%20leisure%20time%2C%20vibrant%20street%20food%20stalls%2C%20cinematic%20travel%20vlog%20aesthetic%2C%20relaxed%20atmosphere&width=640&height=360&seq=video-thumb-07&orientation=landscape',
    duration: '00:08:45',
    views: '680万',
    rating: 9.0,
    description: '跟随镜头漫步成都街头，从宽窄巷子的青石板路到太古里的时尚橱窗，从人民公园的盖碗茶到玉林路的小酒馆。3分钟带你感受成都这座城市独特的慢生活节奏与烟火气息。',
    tags: ['短视频', '旅行', '成都', '生活'],
    releaseDate: '2026-06-10',
    director: '李子柒',
    cast: ['李子柒'],
    featured: false,
  },
  {
    id: 8,
    title: '深海探秘：马里亚纳海沟',
    category: 'documentary',
    thumbnail: 'https://readdy.ai/api/search-image?query=deep%20ocean%20trench%20with%20bioluminescent%20creatures%2C%20dark%20blue%20abyss%2C%20submarine%20exploring%20the%20deepest%20part%20of%20ocean%2C%20mysterious%20underwater%20world%2C%20cinematic%20nature%20documentary%20style%2C%20eerie%20yet%20beautiful%20atmosphere&width=640&height=360&seq=video-thumb-08&orientation=landscape',
    duration: '01:28:15',
    views: '920万',
    rating: 9.4,
    description: '中国"奋斗者"号载人潜水器万米深潜全记录。从海面到海底10909米，镜头记录下人类探索地球上最神秘区域的壮举，揭示深海世界中前所未见的奇异生物与地质奇观。',
    tags: ['纪录片', '海洋', '科学', '探险'],
    releaseDate: '2026-02-08',
    director: '张同道',
    cast: ['中国科学院深海所团队'],
    featured: true,
  },
  {
    id: 9,
    title: '哪吒之魔童闹海',
    category: 'anime',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20animation%20scene%20with%20a%20young%20warrior%20riding%20wind%20and%20fire%20wheels%2C%20dramatic%20red%20silk%20ribbons%20flowing%2C%20epic%20battle%20atmosphere%20with%20stormy%20sky%2C%20vibrant%20colorful%20visual%20effects%2C%20cinematic%20animation%20quality&width=640&height=360&seq=video-thumb-09&orientation=landscape',
    duration: '01:50:32',
    views: '4520万',
    rating: 9.7,
    description: '继前作大获成功后，哪吒系列第二部震撼来袭。天地灵气孕育出一颗混元珠，元始天尊将其提炼成灵珠和魔丸。本应成为灵珠英雄的哪吒却成了混世大魔王，面对命运的不公，哪吒选择"我命由我不由天"的热血抗争。',
    tags: ['动画', '神话', '国漫', '热血'],
    releaseDate: '2025-12-25',
    director: '饺子',
    cast: ['吕艳婷', '囧森瑟夫', '瀚墨'],
    featured: true,
  },
  {
    id: 10,
    title: '一日三餐·家常菜的幸福密码',
    category: 'short',
    thumbnail: 'https://readdy.ai/api/search-image?query=cozy%20home%20kitchen%20with%20steaming%20home-cooked%20Chinese%20dishes%20on%20wooden%20table%2C%20warm%20natural%20window%20light%2C%20family%20gathering%20atmosphere%2C%20rustic%20ceramic%20bowls%20and%20chopsticks%2C%20comfort%20food%20aesthetic%2C%20soft%20homely%20vibe&width=640&height=360&seq=video-thumb-10&orientation=landscape',
    duration: '00:06:22',
    views: '1560万',
    rating: 9.3,
    description: '妈妈的味道，家的温度。从番茄炒蛋到红烧肉，从清炒时蔬到老火靓汤，用最简单的食材，最朴素的烹饪方式，还原每一道家常菜背后那份浓浓的幸福感。',
    tags: ['短视频', '美食', '家常菜', '生活'],
    releaseDate: '2026-07-01',
    director: '日食记',
    cast: ['姜老刀'],
    featured: false,
  },
  {
    id: 11,
    title: '奔跑吧·黄河篇第三季',
    category: 'variety',
    thumbnail: 'https://readdy.ai/api/search-image?query=outdoor%20variety%20show%20scene%20along%20Yellow%20River%20with%20celebrities%20playing%20games%2C%20bright%20sunny%20day%2C%20natural%20landscape%20with%20mountains%20and%20river%2C%20joyful%20competitive%20atmosphere%2C%20colorful%20team%20outfits%2C%20travel%20adventure%20vibe&width=640&height=360&seq=video-thumb-11&orientation=landscape',
    duration: '01:42:18',
    views: '1980万',
    rating: 8.5,
    description: '跑男团沿黄河一路向西，从山东东营入海口到青海源头，用欢笑与汗水丈量母亲河的壮美。本季融入更多黄河文化与生态保护主题，既有爆笑游戏又有深刻思考。',
    tags: ['综艺', '户外', '黄河', '竞技'],
    releaseDate: '2026-06-15',
    director: '姚译添',
    cast: ['李晨', '郑恺', '沙溢', '白鹿', '周深'],
    featured: false,
  },
  {
    id: 12,
    title: '国风音乐盛典·2026',
    category: 'music',
    thumbnail: 'https://readdy.ai/api/search-image?query=grand%20Chinese%20traditional%20music%20concert%20with%20orchestra%20playing%20ancient%20instruments%20like%20guzheng%20and%20erhu%2C%20elegant%20stage%20with%20flowing%20silk%20decorations%2C%20golden%20and%20red%20lighting%2C%20cultural%20gala%20atmosphere%2C%20magnificent%20theatrical%20production&width=640&height=360&seq=video-thumb-12&orientation=landscape',
    duration: '01:55:40',
    views: '720万',
    rating: 9.0,
    description: '年度国风音乐盛宴，集结国内顶级民乐演奏家与国风歌手。古筝、琵琶、二胡、笛箫与现代交响乐碰撞融合，演绎从《高山流水》到《兰亭序》的跨越千年的音乐对话。',
    tags: ['音乐', '国风', '民乐', '盛典'],
    releaseDate: '2026-01-01',
    director: '中央电视台',
    cast: ['方锦龙', '李玉刚', '霍尊', '自得琴社'],
    featured: false,
  },
];